import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { AmplitudeUnmaskDirective } from '../../directives'
import { Color } from '../design-system'

// TODO: VS-145 Align loader icon sizes with design system
// https://fortherecord.atlassian.net/browse/VS-145
export enum LoaderSize {
  Small = 'small',
  Regular = 'regular',
  Large = 'large',
}

@Component({
  selector: 'ftr-loader',
  hostDirectives: [AmplitudeUnmaskDirective],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  @Input() isLoading: boolean
  @Input() loaderText = 'Loading...'
  @Input() fullPage = false
  @Input() iconOnly = false
  @Input() inline = false
  @Input() progress: number
  @Input() color: Color = Color.Primary50
  // Only affects if is inline
  @Input() withSpacer = true
  // Always large for full page loaders
  @Input() size = LoaderSize.Regular

  protected dashOffset = Math.PI * 31 + '%'
  protected readonly loaderSize = LoaderSize

  protected isDeterminate(): boolean {
    return this.progress !== undefined
  }

  getDashArray(progress: number): string {
    return `${progress * Math.PI}% ${(100 - progress) * Math.PI}%`
  }
}
